import request from '../request'

export function fetchList(params) {
    return request({
        url: '/Api/Job/getList',
        params,
    })
}

export function fetchDetail(params) {
    return request({
        url: '/Api/Job/getDetail',
        params
    })
}

